import React, { useEffect } from 'react';
import { Button, Form, Input, Switch } from 'antd';
import { Controller, useForm } from 'react-hook-form';
import { Label } from 'reactstrap';
import { useAuth } from '../../Context/AuthContext';
import { toastSuccess, toastError, toastWarn } from '../Toast/ToastComponent';
import style from '../../Styles/Department.module.css';
import SurveyCategory from '../../Api/SurveyCategoryApi';

const AddSurveyCategory = ({
  modalHeader,
  setModal,
  modal,
  getSurveyCategoryList,
  modalData,
  filterArr,
}) => {
  const { control, handleSubmit, reset, formState } = useForm({
    defaultValues: {
      categoryName: '',
      status: true,
    },
  });

  const { errors } = formState;
  const { authState } = useAuth();

  useEffect(() => {
    if (modalData && modalData.id) {
      reset({
        categoryName: modalData.title || '',
        status: modalData.status, 
      });
    } else {
      reset({
        categoryName: '',
        status: true,
      });
    }
  }, [modalData, reset]);

  const onSubmit = async (data) => {
    try {
      const payload = {
        categoryName: data.categoryName,
        activeStatus: data.status,
      };

      const isEdit =
        modalHeader?.props?.children?.includes('Edit') && modalData?.id;

      if (isEdit) {
        payload.id = modalData.id;
        payload.modified_By_ID = authState.id;

        const response = await SurveyCategory.update(payload);
        if (response.data.success) {
          toastSuccess(response.data.message);
          await getSurveyCategoryList(filterArr);
          setModal(false);
        } else {
          toastWarn(response.data.message);
        }
      } else {
        const response = await SurveyCategory.createSurveyCategory(payload);
        if (response.data.success) {
          toastSuccess(response.data.message);
          await getSurveyCategoryList(filterArr);
          setModal(false);
        } else {
          toastWarn(response.data.message);
        }
      }
    } catch (error) {
      toastError(
        error?.response?.data?.message ||
          error?.message ||
          'Something went wrong',
      );
    }
  };

  return (
    <Form onFinish={handleSubmit(onSubmit)}>
      <Form.Item className={style}>
        <Label>
          Name <span style={{ color: 'red' }}>*</span>
        </Label>
        <Controller
          name="categoryName"
          control={control}
          rules={{ required: 'This field is required' }}
          render={({ field }) => (
            <Input
              {...field}
              disabled={modalHeader?.props?.children === 'View Survey Category'}
              placeholder="Category"
            />
          )}
        />
        {errors?.categoryName && (
          <p className="text-danger">{errors.categoryName.message}</p>
        )}
      </Form.Item>

      <Form.Item className={style}>
        <Controller
          name="status"
          control={control}
          render={({ field }) => (
            <Switch
              checked={field.value}
              disabled={modalHeader?.props?.children === 'View Survey Category'}
              onChange={field.onChange}
            />
          )}
        />
        <span className="ps-2">Active</span>
      </Form.Item>

      {modalHeader?.props?.children !== 'View Survey Category' && (
        <div className="d-flex justify-content-center">
          <Button onClick={() => setModal(!modal)}>Cancel</Button>
          <Button type="primary" htmlType="submit" className="ms-2">
            {modalHeader?.props?.children?.includes('Edit')
              ? 'Update'
              : 'Save'}
          </Button>
        </div>
      )}
    </Form>
  );
};

export default AddSurveyCategory;